<template>
    <div class="publication__edit content-width">

        <div class="publication__edit-wrapper" v-for="c in initial">
            <component :is="c.component.name" :server="server" :key="c.component.name"></component>
        </div>

    </div>
</template>

<script>



const components = [
    { component: SelectLocation },
    { component: PersonalCategories },
    { component: PersonalProfile },
    { component: PublicationEditPreview },
    { component: PublicationSliderGallery },
    { component: PersonalFilters },
]

import StateMixin from "../mixins/StateMixin";

import SelectLocation from "./SelectLocation";
import PersonalCategories from "./PersonalCategories";
import PersonalProfile from "./PersonalProfile";
import PublicationSliderGallery from "./PublicationSliderGallery";
import PublicationEditPreview from "./PublicationEditPreview";
import PersonalFilters from "./PersonalFilters";


export default {
    name: "PublicationEdit",
    props: ['server'],
    mixins: [StateMixin],
    components: {
        SelectLocation, PersonalCategories, PersonalProfile, PublicationEditPreview,
        PublicationSliderGallery, PersonalFilters
    },

    computed: {
        initial() {
            return components
        },

    },

    methods: {
        handleSliderHeight(){
            this.$parent.handleSliderHeight()
        },

        isValid(){
           const v = this.$children.map( e => {
               return e.isValid();
           } );

           if( v.includes(false) ){
               this.$emit('parent-update', false );
               return false
           }

           this.$emit('parent-update', true );
           return true

        }

    },

}
</script>

<style scoped>

</style>
